import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeStorageActionAsync } from '../redux/actions/typeStorageActions'

export const useTypeStorage = () => {
  const { typeStorageState } = useSelector(
    (state: RootState) => state.typeStorage
  )
  const dispatch = useDispatch()

  const getTypeStorage = () => {
    dispatch(getTypeStorageActionAsync())
  }

  return { typeStorageState, getTypeStorage }
}
